module.exports = __webpack_public_path__ + "img/Managed_Service.d4249393.svg";